<template>
    <div>
        <van-nav-bar title='土壤数据统计'  @click-left="back" left-arrow/>
        <div  style="position:absolute;top:46px;left:0;right:0;bottom:0;overflow:auto;background:#ededed">            
            <van-cell title="查询年份:"  :value='search_year_name'  @click="isShowYear = true" is-link />           
            <van-cell title="查询属性:"  :value='search_time_name'  @click="isShowAttribute = true" is-link />
            <van-cell title="详细属性:"  :value='search_attr_more_name'  @click="isShowAttributeMore = true" is-link />            
            <div ref="dom" style="height: 450px;position: relative !important;text-align:center;" v-show="showChar"></div>
            <div v-show="noData" style="height: 310px;position: relative !important;text-align:center;">暂无数据</div>
        </div>

        <!-- 选择年份(单) -->
            <van-popup v-model="isShowYear" get-container="body">
                <van-radio-group v-model="search_year" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in yearList" :key="index" :title="item.label" clickable @click="changeYear(item)">
                            <van-radio slot="right-icon" :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 查询属性 -->
            <van-popup v-model="isShowAttribute" get-container="body">
                <van-radio-group v-model="search_time" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in Attribute" :key="index" :title="item.name" clickable @click="changeAttribute(item,index)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

             <!-- 查询属性(详细) -->
            <van-popup v-model="isShowAttributeMore" get-container="body">
                <van-checkbox-group v-model="search_attr_more" @change='changeAttributeMore'  style="width:200px">
                    <van-cell-group>
                        <van-cell
                        
                        v-for="(item, index) in Attribute_more"
                        clickable
                        :key="index"
                        :title="item.name"
                        @click="attrToggle(index)"
                        >
                        <van-checkbox
                            
                            :name="item.value"
                            ref="attrMoreList"
                            slot="right-icon"
                        />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </van-popup>
    </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
import {getWeatherName,getSoilCount} from '@/request/data'
import echarts from 'echarts'
export default {
    data() {
        return {
            isShowYear:false,
            isShowAttribute:false,
            isShowAttributeMore:false,
            soilUuid:'',
            search_year:'',
            search_year_name:'',
            search_time:'',
            search_time_name:'',
            param_name:'',
            search_attr_more:[],
            search_attr_more_name:[],
            attr:1,
            dom:null,
            attr_name:'',
            showChar:false,
            noData:false,
            WeatherName:[],
            Nmae:[],
            Attribute:[
                {value:1,name:'土壤水分(%)'},
                {value:2,name:'离子浓度(VIC)'},
                {value:3,name:'土壤温度(°C)'},
                {value:4,name:'土壤湿度(RH)'},
            ],
            Attribute_more:[],
            TypeIds:[],
            humiList:[],
            temList:[],
            ionList:[],
            moiList:[],
            weatherInfo:{
                weather_type:1,
                line:[],
                query_year:'',
                uuid:''
            },
            option:{
                title: {
                    text: ''
                },
                tooltip: {
                    confine:true,//该属性为true让tooltip不会超过父标签而显示不全
                    trigger: 'axis'
                },
                legend: {
                    data:[],
                    bottom:0
                },
                dataZoom: [
                    {                        
                        type: 'slider',
                        xAxisIndex: [0],
                        filterMode: 'filter',
                        bottom:'10%'
                    },
                ],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        //saveAsImage: {},
                        magicType: {
                        type: ['line', 'bar'],
                            // show: false
                        },
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [],
            },
        }
    },
    computed: {
        ...mapState(['backIndex']),
        yearList(){
            let myDate = new Date();
            let tYear = myDate.getFullYear();
            this.search_year = tYear
            this.search_year_name = tYear + '年'
            let arr = []
            for (let i = 0; i < 10; i++) {
                let obj = {}
                obj.value = tYear - i
                obj.label = tYear - i + '年'
                arr.push(obj)
            }      
            return arr
        },
    },
    mounted() {
        this.setIsBack(true)
        this.setBackIndex(5)
        this.soilUuid = this.$route.query.uuid
        this.getWeatherName()
    },
    methods: {
        ...mapMutations(['setIsBack','setBackIndex']),
        getWeatherName(){//获取用户绑定的土壤墒情
            let arr = []
            arr.weather_type = 2;
            getWeatherName(arr).then(res=>{
                
                if (res.data.code == 0) {
                    this.WeatherName = res.data.data 
                    for (let i = 0; i < this.WeatherName.length; i++) {
                        if (this.WeatherName[i].uuid == this.soilUuid) {
                            this.Name = this.WeatherName[i].uuid
                            this.weatherInfo.weather_type = this.WeatherName[i].type                            
                            console.log(this.WeatherName[i].uuid)
                            this.getNames(this.WeatherName[i].uuid)
                        }                        
                    }
                    
                }else{

                }
            }).catch(res=>{
            })
        },
         getNames(v){//获取属性            
            let str = v + '';
            str = str.slice(0,1);
            this.Attribute_more = []
            this.TypeIds = []
            this.humiList = []
            this.temList = []
            this.ionList = []
            this.moiList = []
            // console.log(this.WeatherName)
            for (let i = 0; i < this.WeatherName.length; i++) {
                if(this.WeatherName[i].uuid == v){
                    console.log(this.WeatherName.type_ids)
                    for (let j = 0; j < this.WeatherName[i].type_ids.length; j++) {
                        // console.log(this.WeatherName[i].type_ids[j])              
                            let obj = {}
                            switch (this.WeatherName[i].type_ids[j]) {
                            case '106':
                                obj.name = this.WeatherName[i].names[j]
                                obj.value = 'line'+ (j+1)
                                this.humiList.push(obj)
                                break;
                            case '107':
                                obj.name = this.WeatherName[i].names[j]
                                obj.value = 'line'+ (j+1)
                                this.temList.push(obj)
                                break;
                            case '110':
                                obj.name = this.WeatherName[i].names[j]
                                obj.value = 'line'+ (j+1)
                                this.ionList.push(obj)
                                break;
                            case '111':
                                obj.name = this.WeatherName[i].names[j]
                                obj.value = 'line'+ (j+1)                 
                                this.moiList.push(obj)
                                break;              
                            default:
                                break;
                            }
                    }
                     console.log(this.temList)
                }
            }
             console.log(this.humiList)
            this.search_time = 1
            this.search_time_name = this.Attribute[0].name
            // this.search_attr_more = this.moiList
            this.getChartType()
            // this.getChart()
        },
        getChartType(){//维度选择
      
            this.Attribute_more = []
            this.attrTab = true
            this.TypeIds = []

            switch (this.search_time) {
                case 1:          
                if (!this.moiList.length == 0) {
                    console.log(this.moiList)
                    this.Attribute_more = this.moiList
                    this.TypeIds = [...this.moiList]
                    this.search_attr_more = []
                    this.search_attr_more_name = ''
                    for (let i = 0; i < this.moiList.length; i++) {                       
                        this.search_attr_more.push(this.moiList[i].value)                         
                    }                    
                    this.search_attr_more_name = `${this.moiList[0].name},${this.moiList[1].name},+${this.moiList.length-2}...`
                    
                }else{
                    this.attrTab = false            
                }
                break;
                case 2:
                if (!this.ionList.length == 0) {
                    this.Attribute_more = this.ionList
                    this.TypeIds = [...this.ionList]
                    this.search_attr_more = []
                    this.search_attr_more_name = ''
                    for (let i = 0; i < this.ionList.length; i++) {                       
                        this.search_attr_more.push(this.ionList[i].value)
                    }                    
                    this.search_attr_more_name = `${this.ionList[0].name},${this.ionList[1].name},${this.ionList.length-2}+`
                }else{
                    this.attrTab = false
                }
                break;
                case 3:
                if (!this.temList.length == 0) {
                    this.Attribute_more = this.temList
                    this.TypeIds = [...this.temList]
                    this.search_attr_more = []
                    this.search_attr_more_name = ''
                    for (let i = 0; i < this.temList.length; i++) {                       
                        this.search_attr_more.push(this.temList[i].value)                         
                    }                    
                    this.search_attr_more_name = `${this.temList[0].name},${this.temList[1].name},${this.moiList.length-2}+`
                }else{
                    this.attrTab = false            
                }
                break;
                case 4:
                if (!this.humiList.length == 0) {
                    this.Attribute_more = this.humiList
                    this.TypeIds = [...this.humiList]
                    this.search_attr_more = []
                    this.search_attr_more_name = ''
                    for (let i = 0; i < this.humiList.length; i++) {                       
                        this.search_attr_more.push(this.humiList[i].value)                         
                    }                    
                    this.search_attr_more_name = `${this.humiList[0].name},${this.humiList[1].name},${this.humiList.length-2}+`
                }else{
                    this.attrTab = false            
                }
                break;
            
                default:
                break;
            }      
            this.getChart()
        },
        getChart: function () {//获得图表数据并展示
            this.spinShow = true
            this.weatherInfo.line = []
            this.weatherInfo.uuid = this.Name
           
            let lineName = []
            for (let i = 0; i < this.search_attr_more.length; i++) {
                this.weatherInfo.line.push(this.search_attr_more[i])                
                for (let j = 0; j < this.TypeIds.length; j++) {
                    if (this.search_attr_more[i] == this.TypeIds[j].value) {
                           
                            lineName.push(this.TypeIds[j].name)
                             
                    }
                    
                }
                
            }
           
            this.weatherInfo.query_year = this.search_year        
            

            // this.spinShow = true
            this.option.series = [] 
            this.option.legend.data = []
            this.option.xAxis.data = []
            
            
            this.noData = true
            this.showChar = false
            
            console.log(this.weatherInfo)
            getSoilCount(this.weatherInfo).then(res=>{
            console.log(res.data)
            this.spinShow =false
            if (res.data.code == 0) {
                this.noData = false
                this.showChar = true   
                this.option.title.text =  this.search_time_name  
                this.option.series = this.getSeries(JSON.parse(JSON.stringify(res.data.data.weather)),lineName) 
                this.option.legend.data = lineName
                // JSON.parse(JSON.stringify(res.data.data.name))
                this.option.xAxis.data = JSON.parse(JSON.stringify(res.data.data.time))
                this.$nextTick(() => {
                    this.dom = echarts.init(this.$refs.dom,'tdTheme');
                    this.dom.setOption(this.option,true);
                
                })   
                

            }else{
                this.noData = true
                this.showChar = false
            }
            }).catch(res=>{
                this.spinShow = false
            })
        },
        attrToggle(index){           
            this.$refs.attrMoreList[index].toggle();
        },
        getSeries(seriesData,legendData){//处理图表数据
            var series=[];
            for(var i = 0;i<legendData.length;i++){
                series.push({
                    name: legendData[i],
                    type: 'line',
                    data: seriesData[i]
                });
            }
            return series;
        },
        changeYear(item){//改变年份
            this.search_year = item.value
            this.search_year_name = item.label
            this.isShowYear = false
            this.getChart()
        },
        changeAttribute(item,index){
            this.search_time = item.value
            this.search_time_name = item.name
            this.isShowAttribute = false
            this.getChartType()
            console.log(item)
        },
        changeAttributeMore(item){
            let fir = ''
            let sec = '' 
            for (let i = 0; i < this.TypeIds.length; i++) {                
                if (item[0] == this.TypeIds[i].value) {
                    console.log(item,this.TypeIds.length,this.TypeIds[i].name)
                    fir = this.TypeIds[i].name
                }
                if (item[1] == this.TypeIds[i].value) {
                    sec = this.TypeIds[i].name
                }          
            }
           
                if (item.length>2) {
                    this.search_attr_more_name = `${fir},${sec},+${item.length-2}...`
                }else if(item.length == 2){
                    this.search_attr_more_name = `${fir},${sec}`
                }else if(item.length == 1){
                    this.search_attr_more_name = `${fir}`
                }else if(item.length == 0){
                    this.search_attr_more_name = ''
                }
            this.search_attr_more = item
            this.getChart()
            // console.log(item)
        },
        back(){
            this.$router.go(-1)
        },
    },
}
</script>

<style  scoped>

</style>